module.exports = __webpack_public_path__ + "static/media/wvm.6bbf0105.jpg";